import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';

const ValidationMessage = ({ errorsFor = '', errorIndex = -1 }) => {

	const { errors } = useFormContext();

	if (Array.isArray(errors[errorsFor]) && errorIndex > -1) {

		const error = errors[errorsFor][errorIndex];

		if (error && error.message) {

			return (
				<div className="validationMessage">
					<span className="error">
						{error.message}
					</span>
				</div>
			);

		}

	}

	return (
		<>
			{errors[errorsFor] && (
				<div className="validationMessage">
					<span className="error">
						{errors[errorsFor].message}
					</span>
				</div>
			)}
		</>
	);

};

ValidationMessage.propTypes = {
	errorsFor: PropTypes.string.isRequired,
	errorIndex: PropTypes.number
};

export default ValidationMessage;
